<script setup lang="ts">
import { useUserStore } from "@/stores/user"
import { ref } from "vue"
import { useI18n } from "vue-i18n"

import { useFetch, useRuntimeConfig } from "#app"
import { useRoute } from "vue-router"

const userStore = useUserStore()
const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const toaster = useToaster()
const pending = ref(true)

const { data: page, error } = await useFetch(
  `/pages/get-page/${route.params.id}`,
  {
    key: Math.random().toString(36).substring(2),
    baseURL: runtimeConfig.public.baseURL,
  },
)

if (error.value) {
  console.error("Error fetching page:", error.value)
}

definePageMeta({
  // title: page?.value?.header,
  layout: "empty",
  requireLogin: false,
})
useHead({
  // title: page?.value?.header,
})
</script>

<template>
  <div>
    <TairoContentWrapper>
      <div class="p-6 px-8">
        <h1 class="text-3xl text-center mb-4">{{ page?.data?.header }}</h1>
        <div v-html="page?.data?.content"></div>

        <div class="flex flex-col items-center gap-6 mt-8 text-center" v-if="error">
          {{ t("an_error_has_occured") }}

          <BaseButton @click="router.back()" variant="secondary">
            {{ t("back") }}
          </BaseButton>
        </div>
      </div>
    </TairoContentWrapper>
  </div>
</template>
